/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Empty_TitleInputs */

const en_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No resumes yet`)
};

const de_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Lebensläufe`)
};

const fr_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun CV pour le moment`)
};

const es_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay currículums`)
};

const it_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun curriculum ancora`)
};

const nl_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen CV's`)
};

const pl_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak CV`)
};

const fi_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä ansioluetteloita`)
};

const da_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen CV'er endnu`)
};

const sv_resumes_empty_title = /** @type {(inputs: Resumes_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga CV:n ännu`)
};

/**
* | output |
* | --- |
* | "No resumes yet" |
*
* @param {Resumes_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_empty_title = /** @type {((inputs?: Resumes_Empty_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Empty_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_empty_title(inputs)
	if (locale === "fr") return fr_resumes_empty_title(inputs)
	if (locale === "es") return es_resumes_empty_title(inputs)
	if (locale === "it") return it_resumes_empty_title(inputs)
	if (locale === "nl") return nl_resumes_empty_title(inputs)
	if (locale === "pl") return pl_resumes_empty_title(inputs)
	if (locale === "fi") return fi_resumes_empty_title(inputs)
	if (locale === "da") return da_resumes_empty_title(inputs)
	if (locale === "sv") return sv_resumes_empty_title(inputs)
	return en_resumes_empty_title(inputs)
});